import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Happy: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style_2, api_2] = useSpring(() => ({
		from: {
			scale: 1,
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))
	const [style_1, api_1] = useSpring(() => ({
		from: {
			scale: 1,
			x: 0,
			y: 0,
		},
		config: {
			duration: 800,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all([
				api_1.start({
					to: [
						{
							scale: 2,
							x: -250,
							y: -200,
						},
						{
							scale: 1,
							x: 0,
							y: 0,
						},
						{
							scale: 2,
							x: -250,
							y: -200,
						},
						{
							scale: 1,
							x: 0,
							y: 0,
						},
					],
				}),
				api_2.start({
					to: [
						{
							scale: 2,
							x: -180,
							y: -200,
						},
						{
							scale: 1,
							x: 0,
							y: 0,
						},
						{
							scale: 2,
							x: -180,
							y: -200,
						},
						{
							scale: 1,
							x: 0,
							y: 0,
						},
					],
				}),
			]).catch(console.error)
		}
	}, [animate, api_1, api_2])

	return (
		<span>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<circle // ???
					cx="212.6"
					cy="214.6"
					r="121.46"
				/>
				<animated.circle // ???
					cx="170.97"
					cy="182.9"
					r="12.6"
					style={style_2}
				/>
				<animated.circle // ???
					cx="254.23"
					cy="182.9"
					r="12.6"
					style={style_1}
				/>
				<path // ???
					d="m269.64,250.65c-5.68,23.6-29.06,41.27-57.04,41.27s-51.36-17.67-57.05-41.27h114.09Z"
				/>
			</svg>
		</span>
	)
}

export { Happy }
